<template>
    <div name="AddOrUpFieldTmp" style="width: 100%;">
        <el-form
            label-width="120px" label-suffix=":"
            :ref="'form_'+pageId"
            :model="addOrUpData"
            size="small"
            style="width:100%"
        >
            <el-row type="flex" style="flex-wrap:wrap;" >
                <el-col v-for="(fieldSetOne,fieldSetIndex) in fieldSet" :key="'field_'+fieldSetIndex"
                    :xs="24" :sm="24"
                    :md="((addOrUpData[fieldSetOne.inputFName + '_childArr']&&addOrUpData[fieldSetOne.inputFName + '_childArr'].length>0))?24:12"
                    :lg="((addOrUpData[fieldSetOne.inputFName + '_childArr']&&addOrUpData[fieldSetOne.inputFName + '_childArr'].length>0))?24:8"
                    :xl="((addOrUpData[fieldSetOne.inputFName + '_childArr']&&addOrUpData[fieldSetOne.inputFName + '_childArr'].length>0))?24:8"
                    :style="fieldSetOne.isHideSet==1?'display: none;':''"
                >
                    <el-form-item
                        :label="fieldSetOne.fieldCnName"
                        :prop="fieldSetOne.inputFName"
                        :rules="fieldSetOne.isHideSet==1?[]:fieldSetOne.rules"
                        label-width="110px"
                        class="form_item_class"
                    >
                        <span slot="label"  >{{fieldSetOne.fieldCnName}}:
                            <el-button type="primary" size="small" v-if="fieldSetOne.addStyle == 3"
                                :style="fieldSetOne.isHideSetAdd==1?'display: none;':''"
                                @click="clickAddChildPage(fieldSetIndex,null,1)"
                                :fieldId="fieldSetOne.fieldId"
                                icon="el-icon-plus"
                                circle
                            >
                               <!-- [{{addOrUpData[fieldSetOne.inputFName]}}]  -->
                            </el-button>
                        </span>
                        <!-- 判断字段类型  根据字段类型进行对应的输入框的加载 -->
                        <!-- 如果是数字类型的字段 fieldType == 1 -->
                        <div v-if="fieldSetOne.fieldType == 1" >
                            <el-input-number v-model="addOrUpData[fieldSetOne.inputFName]"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                                @change="zdyValueChange($event,fieldSetIndex)"
                            >
                            </el-input-number>
                            <el-tooltip v-if="fieldSetOne.fieldDescribe" effect="dark" :content="fieldSetOne.fieldDescribe" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>

                        <!-- 如果是字符类型的字段 fieldType == 2 -->
                        <!-- 判断 是否必填 (是否可修改) 切换隐藏显示是否清空值 前置条件 默认值 语言设置 (字段描述) 验证条件(提示信息)  -->
                        <div v-if="fieldSetOne.fieldType == 2" >
                            <el-input v-model="addOrUpData[fieldSetOne.inputFName]"
                                suffix-icon="el-icon-document"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                :type="fieldSetOne.showType==1?'textarea':(fieldSetOne.fieldRole==24?'password':'text')"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                                @blur="zdyValueChange($event,fieldSetIndex)"
                            >
                            </el-input>
                            <el-tooltip v-if="fieldSetOne.fieldDescribe" effect="dark" :content="fieldSetOne.fieldDescribe" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>

                        <!-- 如果是日期类型的字段 fieldType == 3 -->
                        <div v-if="fieldSetOne.fieldType == 3">
                            <el-date-picker
                                v-model="addOrUpData[fieldSetOne.inputFName]"
                                placeholder="选择开始"
                                :type="fieldSetOne.vueType"
                                :format="fieldSetOne.dateType"
                                :value-format="fieldSetOne.dateType"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                                @change="zdyValueChange($event,fieldSetIndex)"
                                >
                            </el-date-picker>
                            <el-tooltip v-if="fieldSetOne.fieldDescribe" effect="dark" :content="fieldSetOne.fieldDescribe" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>

                        <!-- 如果是数据字典类型的字段 fieldType == 4。 判断是单选还是多选 根据字段类型 -->
                        <!-- 判断 是否必填 (是否可修改) 切换隐藏显示是否清空值 前置条件 默认值 语言设置 (字段描述) 验证条件(提示信息)  -->
                        <!-- 判断 默认显示值 默认选中值  展现形式  -->
                        <div v-if="fieldSetOne.fieldType == 4" >
                            <!-- 如果设置为 多选框  -->
                            <el-select v-if="fieldSetOne.selectStyle == null || fieldSetOne.selectStyle == 0"
                                v-model="addOrUpData[fieldSetOne.inputFName]" clearable
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                :multiple="fieldSetOne.fieldRole==17?true:false"
                                :multiple-limit="fieldSetOne.dataMaxNum"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                                @change="zdyValueChange($event,fieldSetIndex)"
                            >
                                <el-option
                                    v-for="dicItem in fieldSetOne.dicList"
                                    :key="dicItem.DIC_ID"
                                    :label="dicItem.DIC_NAME"
                                    :value="dicItem.DIC_ID"
                                    :disabled="dicItem.disabled">
                                </el-option>
                            </el-select>
                            <!-- 如果设置为 复选框  -->
                            <el-checkbox-group v-if="fieldSetOne.selectStyle == 1 && fieldSetOne.fieldRole==17"
                                v-model="addOrUpData[fieldSetOne.inputFName]"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                @change="zdyValueChange($event,fieldSetIndex)"
                                :fieldId="fieldSetOne.fieldId"
                            >
                                <el-checkbox
                                    v-for="dicItem in fieldSetOne.dicList"
                                    :key="dicItem.DIC_ID"
                                    :label="dicItem.DIC_ID"
                                >{{dicItem.DIC_NAME}}</el-checkbox>
                            </el-checkbox-group>
                            <!-- 如果设置为单选框 -->
                            <el-radio-group v-if="fieldSetOne.selectStyle == 1 && fieldSetOne.fieldRole==16"
                                v-model="addOrUpData[fieldSetOne.inputFName]"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                @change="zdyValueChange($event,fieldSetIndex)"
                                :fieldId="fieldSetOne.fieldId"
                            >
                                <el-radio
                                    v-for="dicItem in fieldSetOne.dicList"
                                    :key="dicItem.DIC_ID"
                                    :label="dicItem.DIC_ID"
                                >{{dicItem.DIC_NAME}}</el-radio>
                            </el-radio-group>
                            <el-tooltip v-if="fieldSetOne.fieldDescribe" effect="dark" :content="fieldSetOne.fieldDescribe" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>

                        <!-- 如果是弹出层类型的字段 fieldType == 5 -->
                        <div v-if="fieldSetOne.fieldType == 5">
                            <!-- 弹出层字段 -->
                            <el-input v-if="fieldSetOne.chooseType == 0" v-model="addOrUpData[fieldSetOne.inputFName+'_name']"
                                suffix-icon="el-icon-search"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                @focus="openDialog(fieldSetIndex)"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                            >
                            </el-input>

                            <!-- 下拉树字段 -->
                            <el-popover v-if="fieldSetOne.chooseType == 1"
                                placement="bottom"
                                title="选择层"
                                width="400"
                                trigger="click"
                                @show="openTree(0,fieldSetOne)"
                                @hide="openTree(1,fieldSetOne)"
                                v-model="selectData21[fieldSetOne.inputFName+'_openFlag']"
                                >
                                <TreePage v-if="selectData21[fieldSetOne.inputFName+'_openFlag']"
                                    :leftTreePageId="fieldSetOne.pageDialog" :leftTreeTableId="fieldSetOne.dialogTableId"
                                    :dataMaxNumber="(fieldSetOne.fieldRole != 21)?'1':fieldSetOne.dataMaxNum+''"
                                    :ifChooseChild="fieldSetOne.ifChooseChild"
                                    treeType=1
                                    :parentFieldIndex="fieldSetIndex"
                                    :initCheckKeyId="addOrUpData[fieldSetOne.inputFName]+''"
                                    :tmpJsonData="selectData21[fieldSetOne.inputFName+'_tmpJsonData']"
                                    @treeOrDialogCheckCallBack="treeOrDialogCheckCallBack"
                                    @openTree="openTree(1,fieldSetOne)"
                                ></TreePage>
                                <el-input v-model="addOrUpData[fieldSetOne.inputFName+'_name']"
                                    suffix-icon="el-icon-menu"
                                    :disabled="fieldSetOne.ifUpdate==1?false:true"
                                    slot="reference"
                                    class="add_or_up_input"
                                    :fieldId="fieldSetOne.fieldId"
                                >
                                </el-input>
                            </el-popover>
                            <!-- 下拉框字段   -->
                            <el-select v-if="fieldSetOne.chooseType == 2"
                                v-model="addOrUpData[fieldSetOne.inputFName]" clearable
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                :multiple="fieldSetOne.fieldRole==21?true:false"
                                :multiple-limit="fieldSetOne.dataMaxNum"
                                @visible-change="selectVisibleChange($event,fieldSetIndex)"
                                @change="closeSelectObject($event,fieldSetIndex)"
                                :loading="selectData21[fieldSetOne.inputFName+'_loading']"
                                class="add_or_up_input"
                                :fieldId="fieldSetOne.fieldId"
                            >
                                <el-option
                                    v-for="(dicItem,dicIndex) in selectData21[fieldSetOne.inputFName]"
                                    :key="dicIndex"
                                    :label="dicItem.text"
                                    :value="dicItem.value">
                                </el-option>
                            </el-select>

                            <!-- 点击加号新增 -->
                            <el-input v-if="fieldSetOne.addStyle == 3"
                                v-model="addOrUpData[fieldSetOne.inputFName]"
                                style='display:none;'
                            ></el-input>
                            <el-row v-for="(childDataOne,dataIndex) in addOrUpData[fieldSetOne.inputFName + '_childArr']" :key="'childData_'+childDataOne.tmpDataIndex"
                                class="childTableDiv"
                            >
                                <el-col :span="22">
                                    <AddOrUpFieldTmp :ref="'childAddOrUpField_'+fieldSetOne.fieldId"
                                        :tmpfieldSet="fieldSetOne.childFieldSet"
                                        :prevDateIndex="nowPrevAndDateIndex+':'+fieldSetIndex+'-'+dataIndex"
                                        :nowDateIndex="dataIndex+''"
                                        :prevDataId="childDataOne.initData?childDataOne.initData.LMF_ID+'':''"
                                        :prevFieldId="fieldSetOne.fieldId+''"
                                        :name_indexMap="fieldSetOne.name_indexMap"
                                        :pageId="fieldSetOne.showFieldArr+''"
                                        @getNeedFilterDataById="getNeedFilterDataById"
                                        @getFieldValueByFieldId="getFieldValueByFieldId"
                                        @setFieldInfoByFieldId="setFieldInfoByFieldId"
                                        @setValue="setValue"
                                        @clearDialog="clearDialog"
                                        @defaultChoose="defaultChoose"
                                        @zdyParentFun="zdyParentFun" 
                                        @zdyValiadFun="zdyValiadFun" 
                                        :dialogTableId="fieldSetOne.dialogTableId+''"
                                        :pageType="pageType"
                                        :mainDataId="childDataOne.mainDataId+''"
                                        :initData="childDataOne.initData"
                                        :showHideJsList="showHideJsList"
                                        :parentTmpValue="nowTmpValue"
                                        :customVueJs="customVueJs" 
                                        @getChildToHtData="getChildToHtData" 
                                        style="float:left;"
                                    ></AddOrUpFieldTmp>
                                </el-col>
                                <el-col :span="2" :style="childDataOne.isHideSetDelete==1?'display: none;':''">
                                    <!-- 判断是否有排序字段 如果有排序字段加载上下移的图标
                                    <span>
                                        <el-button type="danger" icon="el-icon-arrow-up" circle
                                            @click="clickDelChildPage(fieldSetIndex,dataIndex)"
                                        ></el-button>
                                        <el-button type="danger" icon="el-icon-arrow-down" circle
                                            @click="clickDelChildPage(fieldSetIndex,dataIndex)"
                                        ></el-button>
                                    </span> -->
                                    <span>
                                        <el-button type="danger" icon="el-icon-delete" circle
                                            @click="clickDelChildPage(fieldSetIndex,dataIndex)"
                                        ></el-button>
                                    </span>
                                </el-col>
                            </el-row>
                            <el-tooltip v-if="fieldSetOne.fieldDescribe" effect="dark" :content="fieldSetOne.fieldDescribe" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                        <!-- 附件类型字段 :http-request="myUpload" -->
                        <div v-if="fieldSetOne.fieldType == 6">
                            <el-upload
                                class="upload-demo"
                                :with-credentials="true"
                                :action="'/'+GLOBAL.projectName+'/servlet/OmFileUploadServlet'"
                                :on-success="(response, file, fileList)=> successFile(response, file, fileList,fieldSetOne)"
                                :on-remove="(file, fileList)=> removeFile(file, fileList,fieldSetOne)"
                                :on-exceed="(files, fileList)=> exceedFile(files, fileList,fieldSetOne)"
                                :accept="fieldSetOne.docType"
                                :list-type="fieldSetOne.ifonlyPreView==1?'picture':'text'"
                                :limit="fieldSetOne.dataMaxNum"
                                :disabled="fieldSetOne.ifUpdate==1?false:true"
                                :file-list="addOrUpData[fieldSetOne.inputFName + '_fileList']"
                            >
                                <el-button slot="trigger" size="small" type="primary"
                                    :fieldId="fieldSetOne.fieldId"
                                >点击上传</el-button>
                                <el-popover
                                    placement="right"
                                    width="400"
                                    trigger="click">
                                    <el-carousel indicator-position="outside">
                                        <el-carousel-item v-for="(fileOne,fileIndex) in addOrUpData[fieldSetOne.inputFName + '_fileList']" :key="'fileSee_'+fileIndex">
                                            <span style="float: left;">{{fileOne.name}}</span>
                                            <img :src="''+GLOBAL.projectName+'/DownLoadFile?str='+fileOne.downAddress" style="width:100%;height:100%"/>
                                        </el-carousel-item>
                                    </el-carousel>
                                    <el-button slot="reference" style="margin-left: 10px;" size="small" type="success" >预览</el-button>
                                </el-popover>
                                <div v-if="fieldSetOne.docType&&fieldSetOne.docType.length > 0" slot="tip" class="el-upload__tip">
                                    只能上传{{fieldSetOne.docType}}文件
                                </div>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog v-if="addDialogFlag"
            :title="addDialogTitle"
            :visible.sync="addDialogFlag"
            width=98%
            top="1vh"
            center
            append-to-body>
            <span>
                <!-- 弹出层 -->
                <ListPage v-if="addDialogPageType == 0"
                    :initPageInfo="addDialogPageInfo"
                    ref="addDialogList"
                    @closeListDialog="closeListDialog"
                ></ListPage>
                <!-- 树形结构选择 -->
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogFlag = false">取 消</el-button>
                <el-button type="primary" @click="closeListDialog">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import utils from '@/js/page/pageUtil.js'
import TreePage from '@/components/page/TreePage.vue'


export default {
    name: 'AddOrUpFieldTmp',
    data(){
        return{
            /**
             * form表单的需要传递到后台的输入数据
             */
            addOrUpData:{},
            //弹出层的打开状态
            addDialogFlag:false,
            //弹出层打开的内容类型
            addDialogPageType:0,
            //弹出层打开的弹出层的名称
            addDialogTitle:"选择层",
            //打开弹出层的页面信息
            addDialogPageInfo:{},
            //内部对象多值下拉框的展开项信息
            selectData21:{
            },
            /**
             * 例如是三级结构
             * 学员{联系人  销售机会{订单}} 第几条数据：第几个字段
             * 学员的字段：    学员姓名 0:0  学员手机号 0:1     nowPrevAndDateIndex="0"
             * 学员联系人的字段   第一条数据 联系人姓名 0:2-0:0  联系人电话：0:2-0:1  nowPrevAndDateIndex="0:2-0"
             *                   第一条数据 联系人姓名 0:2-1:0  联系人电话：0:2-1:1  nowPrevAndDateIndex="0:2-1"
             * 学员销售机会的字段 第一条数据 销售机会名称 0:3-0:0  机会校区：0:3-0:1 机会订单()  nowPrevAndDateIndex="0:3-0:"
             *
             */
            nowPrevAndDateIndex:"",

            nowTmpValue:{},

            fieldSet:[]
        }
    },
    methods:{
        /*
         * 文件删除时的处理函数
         */
        removeFile:function(file, fileList,fieldSetOne){
            var toHtId = "";
            fileList.forEach(element => {
                if(element.status == "success") {
                    if(toHtId!="") {
                        toHtId+=","
                    }
                    toHtId+=element.fileId;
                }
            });
            this.addOrUpData[fieldSetOne.inputFName] = toHtId;
        },
        /**
         * 文件上传成功时的处理函数
         */
        successFile:function(response, file, fileList,fieldSetOne){
            var arr = response.split(":");
            var downAddress = arr[0];
            var fileId = arr[1];
            file.fileId = fileId;
            file.downAddress = downAddress;
            var toHtId = "";
            fileList.forEach(element => {
                if(element.status == "success") {
                    if(toHtId!="") {
                        toHtId+=","
                    }
                    toHtId+=element.fileId;
                }
            });
            this.addOrUpData[fieldSetOne.inputFName] = toHtId;
            this.addOrUpData[fieldSetOne.inputFName+"_fileList"] = fileList;
        },
        /**
         * 去预览图片
         */
        toSeeFile:function(fieldSetOne){
            console.log("去预览图片");

        },
        /**
         * 文件上传个数超出时进行提醒
         */
        exceedFile:function(files, fileList, fieldSetOne) {
            this.$message({
                message: '最大文件上传个数为:'+fieldSetOne.dataMaxNum+",不可超出!",
                type: 'warning'
            });
        },

        /**
         * input框切换时 暂时绑定blur事件 传递参数(event: Event)
         * inputNumber切换时 暂时绑定 change (event: Event)
         * select选择框  暂时绑定 change 目前的选中值
         */
        zdyValueChange:function(e,fieldIndex){
            //实现 设置的切换 联动其他显示隐藏的功能 根据 字段Id 判断是否有联动事件包含此字段 如果有则进行切换
            var that = this;
            //获取字段信息
            var fieldSetOne = that.fieldSet[fieldIndex];
            var fieldId = fieldSetOne.fieldId;
            //判断是否需要触发 页面设置的隐藏显示字段信息
            that.initChangeValueShowHide(fieldId);
            if(typeof(this["zdyValueChange_"+fieldId]) == "function") {
                this["zdyValueChange_"+fieldId](this,utils);
            }
            //调用字段的切换自定义js
        },
        /**
         * 根据页面设置的隐藏显示的判断js条件进行隐藏显示的切换
         */
        initChangeValueShowHide:function(fieldId){
            var that = this;
            var showHideJsList = that.showHideJsList;
            if(showHideJsList != null && showHideJsList.length > 0) {
                showHideJsList.forEach(oneJs => {
                    var oneJsArr = oneJs.split("_");
                    var js = oneJsArr[0];
                    var needChangeFieldId = oneJsArr[1];
                    //如果当前切换的字段 已经包含到这个js中 则需要进行判断是否显示和隐藏
                    if(fieldId == 0 || js.indexOf(":"+fieldId+"}") >= 0) {
                        //正则获取js中需要的字段信息
                        var reEs = /#{[\d:]+}/ig;
                        var matchArr =  js.match(reEs);
                        matchArr.forEach(matchOne => {
                            var tmpFieldId = matchOne.substring(matchOne.lastIndexOf(":")+1,matchOne.length-1);
                            var fieldValue = that.getFieldValueByFieldId(tmpFieldId,0);
                            js = js.replace(matchOne, "'"+fieldValue+"'");
                        });
                        var tmpIfHideSet = 0;
                        if(eval(js)) {
                            tmpIfHideSet = 0;
                        } else {
                            tmpIfHideSet = 1;
                        }
                        var showField = that.setFieldInfoByFieldId(needChangeFieldId,0,{"isHideSet":tmpIfHideSet});
                    }
                });
            }
        },
        /**
         * 设置字段的选中值
         * fieldId:赋值的字段
         * findOrder： 0全部查找  1：向上查找  2：向下查找  先向上再向下：3
         *
         */
        setValue:function(fieldId,findOrder,value,name){
            var name_indexMap = this.name_indexMap;
            var reslutObj = null;
            if(name_indexMap['name_'+fieldId] >= 0 && findOrder != 3) {
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[name_indexMap['name_'+fieldId]];
                reslutObj = fieldSetOne;
                var key = fieldSetOne.inputFName;
                if(value != null) {
                    if(fieldSetOne.fieldRole == 16 || fieldSetOne.fieldRole == 23) {
                        value=value*1;
                    } else {
                        value=value+'';
                    }
                    this.addOrUpData[fieldSetOne.inputFName] = value;
                    if(typeof(this["zdyValueChange_"+fieldId]) == "function") {
                        this["zdyValueChange_"+fieldId](this,utils);
                    }
                }
                if(name != null) {
                    this.addOrUpData[fieldSetOne.inputFName+"_name"] = name;
                }
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    if(findOrder != 2) {
                        //先向上层进行寻找
                        this.$emit("setValue",fieldId,1,value,name);
                        reslutObj = this.parentTmpValue.tempChildFindField
                    }
                    if(reslutObj == null && findOrder != 1) {
                        //获取子元素 进行查找
                        //
                        var allChildModel = this.$refs;
                        for(var key in allChildModel){
                            if(key.startsWith("childAddOrUpField")) {
                                var childAddOrUpFieldArr = allChildModel[key];
                                if(childAddOrUpFieldArr) {
                                    for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                                        const element = childAddOrUpFieldArr[index];
                                        element.setValue(fieldId,2,value,name);
                                        if(element.nowTmpValue.tempChildFindField != null) {
                                            if(reslutObj == null) {
                                                reslutObj = [];
                                            }
                                            reslutObj.push(element.nowTmpValue.tempChildFindField);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            var nowTmpValue = this.nowTmpValue;
            nowTmpValue.tempChildFindField = reslutObj;
            return reslutObj;
        },
        /**
         * 根据字段id 从页面中找到对应的字段信息
         * fieldId:需要查找的字段id
         * 查找顺序:全部查找:0 往上层查找:1  往下层查找:2  先向上再向下：3
         */
        setFieldInfoByFieldId:function(fieldId,findOrder,setJson){
            var name_indexMap = this.name_indexMap;
            var reslutObj = null;
            if(name_indexMap['name_'+fieldId] >= 0 && findOrder != 3) {
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[name_indexMap['name_'+fieldId]];
                reslutObj = fieldSetOne;
                if(setJson != null) {
                    for (var key in setJson) {
                        fieldSetOne[key] = setJson[key];
                    }
                }
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    if(findOrder != 2) {
                        //先向上层进行寻找
                        this.$emit("setFieldInfoByFieldId",fieldId,1,setJson);
                        reslutObj = this.parentTmpValue.tempChildFindField;
                    }
                    if(reslutObj == null && findOrder != 1) {
                        //获取子元素 进行查找
                        var allChildModel = this.$refs;
                        for(var key in allChildModel){
                            if(key.startsWith("childAddOrUpField")) {
                                var childAddOrUpFieldArr = allChildModel[key];
                                if(childAddOrUpFieldArr) {
                                    for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                                        const element = childAddOrUpFieldArr[index];
                                        element.setFieldInfoByFieldId(fieldId,2,setJson);
                                        if(element.nowTmpValue.tempChildFindField != null) {
                                            if(reslutObj == null) {
                                                reslutObj = [];
                                            }
                                            reslutObj.push(element.nowTmpValue.tempChildFindField);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            var nowTmpValue = this.nowTmpValue;
            nowTmpValue.tempChildFindField = reslutObj;
            return reslutObj;
        },
        /**
         * 根据字段id 从页面中找到对应的字段信息
         * fieldId:需要查找的字段id
         * 查找顺序:全部查找:0 往上层查找:1  往下层查找:2
         */
        getFieldInfoByFieldId:function(fieldId,findOrder){
            return this.setFieldInfoByFieldId(fieldId,findOrder,null);
        },

        /**
         * 根据字段id 从页面中找到对应的字段
         * fieldId:需要查找的字段id
         * 查找顺序:全部查找:0 往上层查找:1  往下层查找:2    先向上再向下：3
         */
        getFieldValueByFieldId:function(fieldId,findOrder) {
            if(findOrder == null || findOrder == undefined) {
                findOrder = 0;
            }
            var name_indexMap = this.name_indexMap;
            var reslutObj = null;
            if(name_indexMap['name_'+fieldId] >= 0 && findOrder != 3) {
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[name_indexMap['name_'+fieldId]];

                //判断字段类型如果是内部对象多值 则返回数组值
                var key = fieldSetOne.inputFName;
                if(fieldSetOne.fieldRole == 21 || fieldSetOne.fieldRole == 20 || fieldSetOne.fieldRole == 22) {
                    key += "_noChildArr";
                }
                reslutObj = this.addOrUpData[key];
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    //先向上层进行寻找
                    if(findOrder != 2) {
                        this.$emit("getFieldValueByFieldId",fieldId,0);
                        reslutObj = this.parentTmpValue.tempChildFindFieldValue;
                    }
                }

                if(reslutObj == null && findOrder != 1) {
                    //获取子元素 进行查找
                    var allChildModel = this.$refs;
                    for(var key in allChildModel){
                        if(key.startsWith("childAddOrUpField")) {
                            var childAddOrUpFieldArr = allChildModel[key];
                            if(childAddOrUpFieldArr) {
                                for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                                    const element = childAddOrUpFieldArr[index];
                                    element.getFieldValueByFieldId(fieldId,2);
                                    if(element.nowTmpValue.tempChildFindFieldValue != null) {
                                        if(reslutObj == null) {
                                            reslutObj = [];
                                        }
                                        reslutObj.push(element.nowTmpValue.tempChildFindFieldValue);
                                    }
                                }
                            }
                        }
                    }
                }

            }
            var nowTmpValue = this.nowTmpValue;
            nowTmpValue.tempChildFindFieldValue = reslutObj;
            return reslutObj;
        },

        /**
         * 检查form表单 验证是否通过
         */
        checkFormRules:function(){
            //判断是否有分块加载 如果有 则循环块 如果没有则直接获取子页面的form表单校验结果
            var resultCheckArr = [];
            var that = this;
            var resultOne = that.$refs['form_'+that.pageId].validate();
            resultCheckArr.push(resultOne);


            var allChildModel = that.$refs;
            for(var key in allChildModel){
                if(key.startsWith("childAddOrUpField")) {
                    var childAddOrUpFieldArr = allChildModel[key];
                    if(childAddOrUpFieldArr) {
                        for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                            const element = childAddOrUpFieldArr[index];
                            element.checkFormRules();
                            var childResultCheckArr = element.resultCheckArr;
                            childResultCheckArr.forEach(childOne => {
                                resultCheckArr.push(childOne);
                            });
                        }
                    }
                }
            }
            this.resultCheckArr = resultCheckArr;
        },
        /**
         * 获取保存时需要传递到后台的数据
         */
        getToHtData:function(floorIndex){
            var toHtData = {};
            //循环字段 进行
            var fieldSet = this.fieldSet;
            var addOrUpData = this.addOrUpData;
            if(this.mainDataId && this.mainDataId > 0 && this.pageType == 7) {
                toHtData.mainDataId = this.mainDataId;
            } else {
                toHtData.mainDataId = "";
            }
            fieldSet.forEach(element => {
                //判断字段类型 如果是21：内部对象多值 则进行子表格数据的处理
                var tmpVal = addOrUpData[element.inputFName];
                if(tmpVal == undefined) {
                    tmpVal = "";
                }
                console.log("element.zdyAliasName===========",element.zdyAliasName);
                
                if(element.fieldRole == 17) {
                    var tmpId = "";
                    tmpVal.forEach(element => {
                        if(tmpId != "") {
                            tmpId += ",";
                        }
                        tmpId+=element;
                    });
                    //多值选择项
                    if(element.zdyAliasName) {
                        toHtData[element.zdyAliasName] = tmpId;
                    } else {
                        toHtData['t'+floorIndex+'_'+element.inputFName] = tmpId;
                    }
                } else if(element.fieldRole == 19){
                    //多文档
                    if(element.zdyAliasName) {
                        toHtData[element.zdyAliasName] = tmpVal;
                    } else {
                        toHtData['t'+floorIndex+'_'+element.inputFName+'_file_many'] = tmpVal;
                    }
                } else if(element.fieldRole == 21) {
                    //内部对象多值的个数
                    var tmpNum = addOrUpData[element.inputFName+'_num'];
                    if(tmpNum == null || tmpNum == undefined){
                        if(tmpVal == "") {
                            tmpNum = 0;
                        } else {
                            tmpNum = (tmpVal+'').split(",").length;
                        }
                    }
                    if(element.zdyAliasName) {
                        toHtData[element.zdyAliasName] = tmpNum;
                    } else {
                        toHtData['t'+floorIndex+'_'+element.dialogFName+'_dz'] = tmpNum;
                    }
                    if(tmpVal != null && tmpVal != undefined) {
                        if(element.zdyAliasName) {
                            toHtData[element.zdyAliasName+"_ID"] = (tmpVal+'').replace(/,/g,"♆");
                        } else {
                            toHtData['t'+(floorIndex+1)+'_'+element.dialogIdName] = (tmpVal+'').replace(/,/g,"♆");
                        }
                        var updateIdName = element.updateIdName;
                        var childRefArr = this.$refs['childAddOrUpField_'+element.fieldId];
                        if(childRefArr != null && childRefArr.length > 0) {
                            for (let index = 0; index < childRefArr.length; index++) {
                                const childRef = childRefArr[index];
                                childRef.getToHtData(floorIndex+1);
                                var childToHtData = childRef.tmpToHtData;
                                for(var tmpKey in childToHtData) {
                                    if(tmpKey == "mainDataId") {
                                        if(toHtData['t'+(floorIndex+1)+'_'+updateIdName] == undefined) {
                                            toHtData['t'+(floorIndex+1)+'_'+updateIdName] = "";
                                        } else {
                                            toHtData['t'+(floorIndex+1)+'_'+updateIdName] += "♆";
                                        }
                                        toHtData['t'+(floorIndex+1)+'_'+updateIdName] += childToHtData[tmpKey];
                                    } else {
                                        if(toHtData[tmpKey] == undefined) {
                                            toHtData[tmpKey] = "";
                                        } else {
                                            toHtData[tmpKey] += "♆";
                                        }
                                        toHtData[tmpKey] += childToHtData[tmpKey];
                                    }
                                }
                            }
                        } else {
                            //没有子表格 如果是修改则 获取修改的主键 _upDataId
                            var tmpUpdateId = addOrUpData[element.inputFName+'_upDataId'];
                            if(tmpUpdateId == undefined) {
                                tmpUpdateId = "";
                            }
                            if(element.zdyAliasName) {
                                toHtData[element.zdyAliasName+"_mainId"] = (tmpUpdateId+'').replace(/,/g,"♆");
                            } else {
                                toHtData['t'+(floorIndex+1)+'_'+updateIdName] = (tmpUpdateId+'').replace(/,/g,"♆");
                            }
                        }
                    }
                    //t0_au_35_75_328
                } else {
                    if(element.zdyAliasName) {
                        toHtData[element.zdyAliasName] = tmpVal;
                    } else {
                        toHtData['t'+floorIndex+'_'+element.inputFName] = tmpVal;
                    }
                }
            });
            this.tmpToHtData = toHtData;
        },
        /**
         * 弹出层的点击方法
         * addStyle 添加形式：    1：选择对象添加     2：默认全部添加
         * chooseType 选择形式： 0:弹出层  1:树形结构  2:下拉框
         */
        openDialog:function(fieldSetIndex){
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            //判断类型
            this.addDialogPageType = fieldSetOne.chooseType;
            //获取需要打开的页面信息
            var addDialogPageInfo = {};
            addDialogPageInfo.pageId = fieldSetOne.pageDialog;
            addDialogPageInfo.tableId = fieldSetOne.dialogTableId;
            if(fieldSetOne.fieldRole == 21) {
                addDialogPageInfo.dataMaxNum = fieldSetOne.dataMaxNum;
            } else {
                addDialogPageInfo.dataMaxNum = 1;
            }
            //获取打开弹出层时初始选中值 进行弹出层的传递
            var nowCheckId = this.addOrUpData[fieldSetOne.inputFName];
            
            if(nowCheckId != null && nowCheckId != undefined) {
                addDialogPageInfo.nowCheckId = nowCheckId;
            } else {
                addDialogPageInfo.nowCheckId = "";
            }

            //判断是否有 前置的过滤条件 如果有 则获取前置的过滤条件 如果没有则提示需要进行前置操作
            var tmpJsonData = this.getNeedFilterData(fieldSetOne);
            if(tmpJsonData == "终止") {
                return;
            }

            addDialogPageInfo.tmpJsonData = tmpJsonData;
            addDialogPageInfo.fieldSetIndex = fieldSetIndex;

            this.addDialogPageInfo = addDialogPageInfo;
            //打开弹出层 进行数据加载
            this.addDialogFlag = true;
        },
        /**
         * 弹出层选择数据后 点击确定时 进行赋值和弹出层关闭
         */
        closeListDialog:function(){
            //获取弹出层中表格的选中值
            var fieldSetIndex = this.addDialogPageInfo.fieldSetIndex;
            var selectionNodes = this.$refs.addDialogList.selectionNodes;
            this.treeOrDialogCheckCallBack(fieldSetIndex,selectionNodes,0);
            this.addDialogFlag = false;
        },

        /**
         * 初始根据字段id进行点击加号展开的调用
         */
        clickAddChildPageById:function(fieldId,initData){
            var name_indexMap = this.name_indexMap;
            var fieldSetIndex = name_indexMap['name_'+fieldId];
            this.clickAddChildPage(fieldSetIndex,initData,1);
        },
        /**
         * 点击加号时 进行子表格数据的新增
         * 弹出层等选中时 也进行本次调用
         *
         * type = 1 点击加号
         */
        clickAddChildPage:function(fieldSetIndex, initData, type, initAddOrUpData){
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var addOrUpData = initAddOrUpData;
            if(initAddOrUpData == null || initAddOrUpData == undefined) {
                addOrUpData = this.addOrUpData;
            }
            var childArr = addOrUpData[fieldSetOne.inputFName + '_childArr'];
            var maxIndex = -1;
            childArr.forEach(element => {
                if(element.tmpDataIndex > maxIndex) {
                    maxIndex = element.tmpDataIndex;
                }
            });
            var mainDataId = 0;
            if(initData != null) {
                mainDataId = initData['T_' + fieldSetOne.relationTableId + '_0'];
            }
            childArr.push({
                tmpDataIndex:maxIndex+1,
                initData:initData,
                mainDataId:mainDataId
            });
            addOrUpData[fieldSetOne.inputFName+'_num'] = childArr.length;
            if(type == 1) {
                addOrUpData[fieldSetOne.inputFName] = childArr.length;
            }
            //this.addOrUpData = addOrUpData;
        },
        /**
         * 子表格的删除按钮 点击时进行子表格数据的删除
         */
        clickDelChildPage:function(fieldSetIndex,dataIndex){
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var addOrUpData = this.addOrUpData;
            var childArr = addOrUpData[fieldSetOne.inputFName + '_childArr'];
            childArr.splice(dataIndex, 1);
            addOrUpData[fieldSetOne.inputFName+'_num'] = childArr.length;
            if(childArr.length > 0) {
                addOrUpData[fieldSetOne.inputFName] = childArr.length;
            } else {
                addOrUpData[fieldSetOne.inputFName] = '';
            }
        },
        /**
         * 自定义js 给元素绑定 过滤字段属性
         */
        bindNeedFilterData:function(fieldId,plugId,value){
            var name_indexMap = this.name_indexMap;
            var fieldSetIndex = name_indexMap['name_'+fieldId];
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var filterJson = fieldSetOne.filterJson;
            if(filterJson == null) {
                fieldSetOne.filterJson = {};
            }
            fieldSetOne.filterJson["filter_"+plugId] = value;
        },
        /**
         * 获取弹出层 下拉树 数据下拉框的前置过滤条件
         */
        getNeedFilterData:function(fieldSetOne){
            var needFilter = fieldSetOne.needFilter;
            var tmpJsonData = "";
            if (needFilter != null && needFilter.length > 0) {
                var noInfoPrompt = "";
                var needFilterArr = needFilter.split(",");
                for (var i = 0; i < needFilterArr.length; i++) {
                    if (needFilterArr[i].indexOf("SESSION") == -1) {
                        var tmpOneArr = needFilterArr[i].split(":");
                        var tmpId = null;
                        var tmpFieldCnName = "";
                        if (tmpOneArr.length > 1) {
                            var fieldId = tmpOneArr[1];
                            //判断当前元素上是否有filter_fieldId属性 如果有则直接获取值 如果没有则在页面中进行查找
                            var filterJson = fieldSetOne.filterJson;
                            if(filterJson != null) {
                                var filterId = filterJson["filter_"+fieldId];
                                if(filterId != null && filterId != undefined) {
                                    tmpId = filterId
                                }
                            }
                            if(tmpId == null) {
                                var returnMap = this.getNeedFilterDataById(fieldId);
                                tmpId = returnMap.tmpId;
                                if(tmpId != null && tmpId != undefined && (tmpId+'').length > 0) {
                                    tmpJsonData += "&" + tmpOneArr[0] + "=" + tmpId;
                                } else {
                                    noInfoPrompt = returnMap.noInfoPrompt;
                                }
                            } else {
                                tmpJsonData += "&" + tmpOneArr[0] + "=" + tmpId;
                            }
                        }
                    }
                    if(noInfoPrompt != "") {
                        this.$message.error(noInfoPrompt);
                        return "终止";
                    }
                }
            }
            return tmpJsonData;
        },
        /**
         * 获取对应的弹出层或者下拉树的 需要过滤的条件
         * 首先判断本层是否有对应的过滤字段：如果有则获取值 如果没有则判断本层的主键是否是对应的字段 如果不是则 进行上一层的判断
         */
        getNeedFilterDataById:function(fieldId){
            var name_indexMap = this.name_indexMap;
            var tmpId = null;
            var noInfoPrompt = "";
            var returnMap = {};
            var nowTmpValue = this.nowTmpValue;
            if(name_indexMap['name_'+fieldId] >= 0) {
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[name_indexMap['name_'+fieldId]];
                tmpId = this.addOrUpData[fieldSetOne.inputFName];
                if(tmpId == null || tmpId == undefined || tmpId.length == 0) {
                    noInfoPrompt = "必须先填写：" + fieldSetOne.fieldCnName + " 否则不可以选择此项";
                }
                returnMap.tmpId = tmpId;
                returnMap.noInfoPrompt = noInfoPrompt;
                nowTmpValue.tmpReturnMap = returnMap;
                return returnMap;
            } else if(fieldId == this.prevFieldId) {
                //上一层的触发字段是否是这个字段
                tmpId = this.prevDataId;
                if(tmpId == null || tmpId == undefined || tmpId.length == 0) {
                    noInfoPrompt = "未获取到上一层选中的值：不可以选择此项";
                }
                returnMap.tmpId = tmpId;
                returnMap.noInfoPrompt = noInfoPrompt;
                nowTmpValue.tmpReturnMap = returnMap;
                return returnMap;
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    this.$emit("getNeedFilterDataById",fieldId);
                    returnMap = this.parentTmpValue.tmpReturnMap;
                    nowTmpValue.tmpReturnMap = returnMap;
                    return returnMap;
                } else {

                    tmpId = this.mainDataId;
                    returnMap.tmpId = tmpId;
                    returnMap.noInfoPrompt = noInfoPrompt;
                    nowTmpValue.tmpReturnMap = returnMap;
                    return returnMap;
                }
            }
        },
        /**
         * 打开下拉树
         */
        openTree:function(flag,fieldSetOne){
            var selectData21 = this.selectData21;
            if(flag == 0) {
                //获取前置的树的联动过滤条件
                //判断是否有 前置的过滤条件 如果有 则获取前置的过滤条件 如果没有则提示需要进行前置操作
                var tmpJsonData = this.getNeedFilterData(fieldSetOne);
                console.log("tmpJsonData=====================",tmpJsonData);
                
                if(tmpJsonData == "终止") {
                    return;
                }
                selectData21[fieldSetOne.inputFName+'_tmpJsonData'] = tmpJsonData;
                console.log("selectData21=========================",selectData21);
                
                selectData21[fieldSetOne.inputFName+'_openFlag'] = true;
            } else {
                console.log("flag================",flag,fieldSetOne.inputFName);
                
                selectData21[fieldSetOne.inputFName+'_openFlag'] = false;
                selectData21[fieldSetOne.inputFName+'_tmpJsonData'] = "";
            }

            this.selectData21 = selectData21;
        },
        /**
         * 对象下拉框 打开时加载下拉框数据
         */
        selectVisibleChange:function(flag,fieldSetIndex){
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var selectData21 = this.selectData21;
            if(flag) {
                var tmpJsonData = this.getNeedFilterData(fieldSetOne);
                if(tmpJsonData == "终止") {
                    return;
                }
                var toHtData = {};
                if(tmpJsonData != null && tmpJsonData.length > 0) {
                    var tmpJsonDataArr = tmpJsonData.split("&");
                    for (let index = 0; index < tmpJsonDataArr.length; index++) {
                        const element = tmpJsonDataArr[index];
                        var elementArr = element.split("=");
                        if(elementArr.length > 1) {
                            toHtData[elementArr[0]] = elementArr[1];
                        }
                    }
                }
                //去后台进行下拉框数据加载
                selectData21[fieldSetOne.inputFName+'_loading'] = true;
                var url = "/model_ajaxList.do";
                toHtData.pageId = fieldSetOne.pageDialog;
                toHtData.tableId = fieldSetOne.dialogTableId;
                toHtData.ifGetAll = 1;
                //关联的过滤条件
                //toHtData.tmpJsonData = ;
                //进行后台数据搜索
                this.$axios.post(url,toHtData).then(res => {
                    selectData21[fieldSetOne.inputFName] = res.data;
                    this.selectData21 = selectData21;
                    selectData21[fieldSetOne.inputFName+'_loading'] = false;
                }).catch(error => {
                    console.log("=====" + error);
                })
            } else{
                //清除下拉框数据
                selectData21[fieldSetOne.inputFName] = [];
                this.selectData21 = selectData21;
            }
        },
        /**
         * 弹出层默认选中
         */
        defaultChoose:function(fieldId,findOrder){
            if(findOrder == null || findOrder == undefined) {
                findOrder = 0;
            }
            var name_indexMap = this.name_indexMap;
            var reslutObj = null;
            if(name_indexMap['name_'+fieldId] >= 0) {
                var fieldSetIndex = name_indexMap['name_'+fieldId];
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[fieldSetIndex];
                this.defaultChooseNowFloor(fieldSetIndex);
                reslutObj = this.addOrUpData[fieldSetOne.inputFName];
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    //先向上层进行寻找
                    if(findOrder != 2) {
                        this.$emit("defaultChoose",fieldId,1);
                        reslutObj = this.parentTmpValue.tempChildFindFieldValue;
                    }
                    if(reslutObj == null && findOrder != 1) {
                        //获取子元素 进行查找
                        var allChildModel = this.$refs;
                        for(var key in allChildModel){
                            if(key.startsWith("childAddOrUpField")) {
                                var childAddOrUpFieldArr = allChildModel[key];
                                if(childAddOrUpFieldArr) {
                                    for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                                        const element = childAddOrUpFieldArr[index];
                                        element.defaultChoose(fieldId,2);
                                        if(element.nowTmpValue.tempChildFindFieldValue != null) {
                                            if(reslutObj == null) {
                                                reslutObj = [];
                                            }
                                            reslutObj.push(element.nowTmpValue.tempChildFindFieldValue);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            var nowTmpValue = this.nowTmpValue;
            nowTmpValue.tempChildFindFieldValue = reslutObj;
        },
        /**
         * 清除弹出层的选中
         */
        clearDialog:function(fieldId,findOrder){
            if(findOrder == null || findOrder == undefined) {
                findOrder = 0;
            }
            var name_indexMap = this.name_indexMap;
            var reslutObj = null;
            if(name_indexMap['name_'+fieldId] >= 0) {
                var fieldSetIndex = name_indexMap['name_'+fieldId];
                //本层是否有这个过滤字段
                var fieldSetOne = this.fieldSet[fieldSetIndex];
                this.clearDialogNowFloor(fieldSetIndex);
                reslutObj = this.addOrUpData[fieldSetOne.inputFName];
            } else {
                //进行递归 如果prevDateIndex 等于"" 则为最外层 不用再递归 可以获取页面主键
                if(this.prevDateIndex != "") {
                    //先向上层进行寻找
                    if(findOrder != 2) {
                        this.$emit("clearDialog",fieldId,1);
                        reslutObj = this.parentTmpValue.tempChildFindFieldValue;
                    }
                    if(reslutObj == null && findOrder != 1) {
                        //获取子元素 进行查找
                        var allChildModel = this.$refs;
                        for(var key in allChildModel){
                            if(key.startsWith("childAddOrUpField")) {
                                var childAddOrUpFieldArr = allChildModel[key];
                                if(childAddOrUpFieldArr) {
                                    for (let index = 0; index < childAddOrUpFieldArr.length; index++) {
                                        const element = childAddOrUpFieldArr[index];
                                        element.clearDialog(fieldId,2);
                                        if(element.nowTmpValue.tempChildFindFieldValue != null) {
                                            if(reslutObj == null) {
                                                reslutObj = [];
                                            }
                                            reslutObj.push(element.nowTmpValue.tempChildFindFieldValue);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            var nowTmpValue = this.nowTmpValue;
            nowTmpValue.tempChildFindFieldValue = reslutObj;
        },
        /**
         * 弹出层 下拉框 后台默认选中
         */
        defaultChooseNowFloor:function(fieldSetIndex){
            var that = this;
            //本层是否有这个过滤字段
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var tmpJsonData = this.getNeedFilterData(fieldSetOne);
            if(tmpJsonData == "终止") {
                return;
            }
            var toHtData = {};
            if(tmpJsonData != null && tmpJsonData.length > 0) {
                var tmpJsonDataArr = tmpJsonData.split("&");
                for (let index = 0; index < tmpJsonDataArr.length; index++) {
                    const element = tmpJsonDataArr[index];
                    var elementArr = element.split("=");
                    if(elementArr.length > 1) {
                        toHtData[elementArr[0]] = elementArr[1];
                    }
                }
            }
            //去后台进行下拉框数据加载
            var url = "/model_ajaxList.do";
            var checkType = 0;
            //如果是下拉树
            if(fieldSetOne.chooseType == 1) {
                url = "/treeDialog_ajaxList.do";
                checkType = 1;
            }
            toHtData.pageId = fieldSetOne.pageDialog;
            toHtData.tableId = fieldSetOne.dialogTableId;
            toHtData.start = 0;
            toHtData.limit = 1000;
            toHtData.ifAjax = 1;
            //关联的过滤条件
            //toHtData.tmpJsonData = ;
            //进行后台数据搜索
            this.$axios.post(url,toHtData).then(res => {
                if(fieldSetOne.chooseType == 1) {
                    var selectionNodes = res.data;
                    that.treeOrDialogCheckCallBack(fieldSetIndex,selectionNodes,checkType);
                } else{
                    var selectionNodes = res.data.rows;
                    that.treeOrDialogCheckCallBack(fieldSetIndex,selectionNodes,checkType);
                }
            }).catch(error => {
                console.log("=====" + error);
            })
        },
        /**
         * 清空弹出层等的选中状态  只能清空本层的
         */
        clearDialogNowFloor:function(fieldSetIndex){
            var that = this;
            //本层是否有这个过滤字段
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var checkType = 0;
            if(fieldSetOne.chooseType == 1) {
                checkType = 1;
            }
            that.treeOrDialogCheckCallBack(fieldSetIndex,[],checkType);
        },
        /**
         * 数据下拉框 选中值切换时调用
         */
        closeSelectObject:function(selectValue,fieldSetIndex){
            var fieldSetOne = this.fieldSet[fieldSetIndex];
            var selectData21 = this.selectData21;
            var dataArr = selectData21[fieldSetOne.inputFName];
            var checkNodes = [];
            if(fieldSetOne.fieldRole == 21) {
                //多选
                selectValue.forEach(element => {
                    dataArr.forEach(dataOne => {
                        if(dataOne.value == element) {
                            checkNodes.push(dataOne);
                        }
                    });
                });
            } else {
                dataArr.forEach(dataOne => {
                    if(dataOne.value == selectValue) {
                        checkNodes.push(dataOne);
                    }
                });
            }
            this.treeOrDialogCheckCallBack(fieldSetIndex,checkNodes,2);
        },
        /**
         * 下拉树 或者 弹出层 选中时 回调进行赋值
         * chooseType 选择形式： 0:弹出层  1:树形结构  2:下拉框
         */
        treeOrDialogCheckCallBack:function(fieldIndex, checkedNodes, type, relationTableId, initAddOrUpData){
            var fieldSetOne = this.fieldSet[fieldIndex];
            var showName = "NAME";
            //获取第一个字段
            var childFieldSet = fieldSetOne.childFieldSet;
            var checkId = "";
            var checkName = "";
            var updateDataId = "";
            var addOrUpData = initAddOrUpData;
            if(initAddOrUpData == null || initAddOrUpData == undefined) {
                addOrUpData = this.addOrUpData;
            }
            addOrUpData[fieldSetOne.inputFName + '_childArr'] = [];
            addOrUpData[fieldSetOne.inputFName + '_noChildArr'] = [];
            var clickType = 0;
            if(fieldSetOne.addStyle == 3) {
                clickType = 1;
            }
            for (let index = 0; index < checkedNodes.length; index++) {
                const element = checkedNodes[index];
                if(type == 0) {
                    if(childFieldSet != null && childFieldSet.length > 0) {
                        if(element.ifUpdate) {
                            showName = childFieldSet[0].fieldAliasName;
                        } else {
                            showName = childFieldSet[0].dialogFieldAliasName;
                        }
                    }
                    if(relationTableId != null && relationTableId != undefined) {
                        showName = "F_" + fieldSetOne.dialogTableId + "_" + showName;
                    }
                }
                //获取名称 和 id 进行拼接显示
                if(checkId != "") {
                    checkId += ",";
                    checkName += ",";
                }
                if(type == 1) {
                    if(relationTableId != null && relationTableId != undefined) {
                        checkId += element.ID;
                        checkName += element.NAME;
                    } else {
                        checkId += element.id;
                        checkName += element.name;
                    }
                } else if(type == 0){
                    element.checkId = element["T_" + fieldSetOne.dialogTableId + "_0"];
                    element.checkName = element[showName];
                    checkId += element["T_" + fieldSetOne.dialogTableId + "_0"]+"";
                    checkName += element[showName]+"";
                } else if(type == 2) {
                    checkId += element.value;
                    checkName += element.text;
                }
                //判断是否需要进行子表格的加载 如果子表格的元素个数大于1个 则进行子表格加载
                if(childFieldSet.length > 1) {
                    this.clickAddChildPage(fieldIndex,element,clickType,addOrUpData);
                } else {
                    if(updateDataId != "") {
                        updateDataId += ",";
                    }
                    var childUpDataId = element['T_' + fieldSetOne.relationTableId + '_0'];
                    if(childUpDataId && childUpDataId > 0) {
                        updateDataId += childUpDataId;
                    } else {
                        updateDataId += "";
                    }
                }
                addOrUpData[fieldSetOne.inputFName + '_noChildArr'].push(element);
            }
            var fieldId = fieldSetOne.fieldId;
            
            if(clickType == 0) {
                addOrUpData[fieldSetOne.inputFName] = checkId;
            }
            if(type != 2) {
                addOrUpData[fieldSetOne.inputFName+'_name'] = checkName;
            }
            if(updateDataId != "") {
                addOrUpData[fieldSetOne.inputFName+'_upDataId'] = updateDataId;
            }

            if(typeof(this["zdyValueChange_"+fieldId]) == "function") {
                this["zdyValueChange_"+fieldId](this,utils);
            }
            //子表格信息绑定 暂时先不加 一会再加
            //this.addOrUpData = addOrUpData;
        },
        /**
         * 加载字段的默认值
         * @param {*} onedate
         * @param {*} fmt
         */
        replaceFieldOneDefault : function(oneField,pageType,addOrUpData){
            var defaultValStr = oneField.defaultValStr;
            var defaultCheckValue = oneField.defaultCheckValue;
            //为空是否显示默认值
            var ifNullShowDefVal = oneField.ifNullShowDefVal;
            //是否强制显示默认值
            var ifShowDefVal = oneField.ifShowDefVal;
            //选中的数据个数 dataMaxNum
            var dataMaxNum = oneField.dataMaxNum;
            if (pageType == 7) {
                //如果是修改页面 是否强制显示默认值为否 并且
                if (ifShowDefVal == 0 && (ifNullShowDefVal == 0 || defaultValStr == null)) {
                return;
                }
            }
            //登陆人的按钮列表信息
            if (defaultValStr != null && defaultValStr != undefined && typeof defaultValStr != "number") {
                if (defaultValStr.indexOf("&{SESSION_") == 0) {
                    //从登陆缓存中获取 sessionMap
                    var sessionMap = JSON.parse(sessionStorage.sessionMap);
                    var sessionId = defaultValStr.substring(12, defaultValStr.lastIndexOf("_"));
                    var checkedId = sessionMap['SESSION_' + sessionId];
                    var checkedName = sessionMap['SESSION_NAME_' + sessionId];
                    if (dataMaxNum == 1) {
                        checkedId = checkedId.split(",")[0];
                        checkedName = checkedName.split(",")[0];
                    }
                    addOrUpData[oneField.inputFName] = checkedId;
                    addOrUpData[oneField.inputFName + '_name'] = checkedName;
                } else if (defaultValStr.indexOf("${USER_") == 0) {
                    var loginInfo = JSON.parse(sessionStorage.loginInfo);
                    var tmpUserName = defaultValStr.substring(2, defaultValStr.length - 1);
                    addOrUpData[oneField.inputFName] = loginInfo[tmpUserName];
                    addOrUpData[oneField.inputFName + '_name'] = loginInfo[tmpUserName];
                } else if (defaultValStr.indexOf("${USERID}") == 0 || defaultValStr.indexOf("${USERID_2}") == 0 || defaultValStr.indexOf("${USERID_26}") == 0) {
                    var loginInfo = JSON.parse(sessionStorage.loginInfo);
                    var checkedId = loginInfo.USERID;
                    var checkedName = loginInfo.USERNAME;
                    addOrUpData[oneField.inputFName] = checkedId;
                    addOrUpData[oneField.inputFName + '_name'] = checkedName;
                }  else if (defaultValStr.indexOf("${sysdate") == 0) {
                    var format = defaultValStr.substring(defaultValStr.indexOf("_") + 1, defaultValStr.length - 1)
                    var date = new Date();
                    addOrUpData[oneField.inputFName] = utils.dateFormat(date,format);
                }
            } else if(defaultCheckValue != null && defaultCheckValue != undefined && defaultCheckValue.length > 0){
                if(oneField.fieldRole == 17) {
                    var tmpArr = defaultCheckValue.split(",");
                    var numberArr = [];
                    tmpArr.forEach(element => {
                        numberArr.push(element*1);
                    });
                    addOrUpData[oneField.inputFName] = numberArr;
                } else {
                    addOrUpData[oneField.inputFName] = defaultCheckValue*1;
                }
            }
        },
        /**
         * 修改页面初始化显示值
         */
        replaceInitData:function(dataInfo,oneField,addOrUpData,selectData21,fieldIndex){
            var aliasName = oneField.fieldAliasName;
            var dialogTableId = this.dialogTableId;
            var dialogFieldAliasName = oneField.dialogFieldAliasName;
            var fieldRole = oneField.fieldRole;
            var inputFName = oneField.inputFName;
            var lmfValueFirstAliasName = oneField.lmfValueFirstAliasName;
            //内部对象时的展现形式 下拉框
            var chooseType = oneField.chooseType;
            //内部对象多值时 子表格需要的两个字段
            var relationTableId = oneField.relationTableId;
            var showFieldArr = oneField.showFieldArr;
            var aliasValue = "";
            //如果别名 并且 不是弹出层类型字段 直接根据别名获取值进行替换展示
            if (aliasName && aliasName != undefined) {
                //dialogFieldAliasName 不为空的情况有两种情况 一种是修改页面 则需要加F_  另一种是弹出层选中值赋值 则不需要增加aliasName
                //在弹出层选中值的情况下 dialogFieldAliasName 不为空不需要进行赋值
                if(dataInfo.ifUpdate) {
                    if ((dialogTableId > 0 && dialogFieldAliasName && dialogFieldAliasName != undefined)) {
                        aliasName = "F_" + dialogTableId + "_" + aliasName;
                    }
                    aliasValue = dataInfo[aliasName];
                } else {
                    if(dialogFieldAliasName && dialogFieldAliasName != undefined) {
                        aliasValue = dataInfo[dialogFieldAliasName];
                    } else {
                        return;
                    }
                }
                //日期类型是否需要做特殊处理  暂定中
                var dateType = oneField.dateType;
                if (dateType && dateType != "") {
                    //如果是日期类型进行截取
                    if(aliasValue) {
                        var date = new Date(aliasValue);
                        aliasValue = utils.dateFormat(date, dateType);
                    }
                }
                if(fieldRole == 20 || fieldRole == 22) {
                    //如果显示值类型为下拉框 则需要进行数据的初始化赋值  处理显示为ID的问题
                    var aliasValueName = dataInfo[lmfValueFirstAliasName];
                    if(chooseType == 2) {
                        selectData21[inputFName] = [{text:aliasValueName,value:aliasValue}];
                    }
                    addOrUpData[inputFName+'_name'] = aliasValueName;
                    if(aliasValue != null && aliasValue != undefined && aliasValue > 0) {
                        
                        //chooseType 选择形式： 0:弹出层  1:树形结构  2:下拉框
                        dataInfo.ifUpdate = true;
                        var checkNodes = [dataInfo];
                        checkNodes[0]["T_" + oneField.dialogTableId + "_0"] = aliasValue;
                        console.log("checkNodes==========",checkNodes,aliasValue,aliasValueName);
                        if(chooseType == 1) {
                            checkNodes[0].id = aliasValue+"";
                            checkNodes[0].name = aliasValueName;
                        }
                        this.treeOrDialogCheckCallBack(fieldIndex,checkNodes,chooseType,null,addOrUpData);
                    }
                }
                addOrUpData[inputFName] = aliasValue;
                //单文档类型 进行
                if(fieldRole == 18) {
                    //获取文件信息 并进行fileList的绑定
                    var tmpFileList = dataInfo[aliasName+"_fileList"];
                    if(tmpFileList != null) {
                        var fileList = [];
                        tmpFileList.forEach(tmpFile => {
                            fileList.push({
                                fileId:tmpFile.F_ID+"",
                                name:tmpFile.F_NAME,
                                size: tmpFile.F_SIZE,
                                downAddress:tmpFile.F_MONGOID,
                                status:"success"
                            });
                        });
                        addOrUpData[inputFName+"_fileList"] = fileList;
                    }
                }
            } else if(fieldRole == 17){
                //多值选择项类型的字段
                var tmpInputFName = inputFName.substring(0, inputFName.lastIndexOf("_"));
                aliasValue = dataInfo[tmpInputFName + "_dicSql"];
                var tmpArr = aliasValue.split(",");
                var numberArr = [];
                tmpArr.forEach(element => {
                    numberArr.push(element*1);
                });
                addOrUpData[inputFName] = numberArr;
            } else if(fieldRole == 19) {
                aliasValue = dataInfo[inputFName + "_fileSql"];
                addOrUpData[inputFName] = aliasValue;
                //获取文件信息 并进行fileList的绑定
                var tmpFileList = dataInfo[inputFName + "_fileSql"+"_fileList"];
                if(tmpFileList != null) {
                    var fileList = [];
                    tmpFileList.forEach(tmpFile => {
                        fileList.push({
                            fileId:tmpFile.F_ID+"",
                            name:tmpFile.F_NAME,
                            size: tmpFile.F_SIZE,
                            downAddress:tmpFile.F_MONGOID,
                            status:"success"
                        });
                    });
                    addOrUpData[inputFName+"_fileList"] = fileList;
                }
            } else if(relationTableId > 0) {
                //子表格数据加载
                var checkNodes = dataInfo[relationTableId + "_" + showFieldArr];
                if(oneField.zdyAliasName) {
                    checkNodes = dataInfo[oneField.zdyAliasName];
                }
                if (checkNodes == null || checkNodes == undefined) {
                    return;
                }
                checkNodes.forEach(element => {
                    element.ifUpdate = true;
                });

                this.treeOrDialogCheckCallBack(fieldIndex,checkNodes,chooseType,relationTableId,addOrUpData);
            }
        },
        zdyParentFun:function(type){
            if(typeof(this.zdyParentFunExe) == "function") {
                this.zdyParentFunExe(this,type,utils);
            }
        },
        zdyValiadFun:function(fieldId,mainId){
            if(typeof(this.zdyValiadFunExe) == "function") {
                this.zdyValiadFunExe(this,fieldId,mainId);
            }
        },
        getChildToHtData : function () {
            this.$emit('getChildToHtData');
        },
    },

    /**
     * 页面创建时 进行后台数据请求 请求页面设置信息 之后再做浏览器端缓存
     */
    beforeMount : function(){
        var that = this;
        this.fieldSet = JSON.parse(JSON.stringify(this.tmpfieldSet));
        var addOrUpData = {};
        var pageType = this.pageType;
        var selectData21 = {};
        var nowPrevAndDateIndex = (this.prevDateIndex ==""?"":this.prevDateIndex+"-") + this.nowDateIndex;
        this.nowPrevAndDateIndex = nowPrevAndDateIndex;

        var fieldSet = this.fieldSet;
        if(fieldSet != undefined) {
            var fieldIndex = 0;
            fieldSet.forEach(element => {
                //获取form表单验证信息 进行rules拼接
                var ifMust = element.ifMust;
                var ifToHtValid = element.ifToHtValid;//是否走后台验证
                var oneRules = [];
                if(ifMust == 1) {
                    oneRules.push({
                        required: true,
                        message: '必须填写',
                        trigger: ['change','blur']
                    });
                    addOrUpData[element.inputFName] = "";
                } else {
                    addOrUpData[element.inputFName] = "";
                }

                if (ifToHtValid==1) {//是否走后台验证
                    console.log("--------走后台验证------",element);
                    var checkDataToHt = (rule, value, callback) => {
                        var url = '/add_dataValid.do';
                        if (value==null || value.length==0) {
                                return callback();
                        } else {
                            var pageId = that.pageId;

                            var tableId = element.tableId;
                            var mainDataId = that.mainDataId;
                            var toHtData = {};
                            toHtData.tableId = tableId;
                            toHtData.pageId = pageId;
                            if (mainDataId!=null && mainDataId>0) {
                                toHtData.id = mainDataId;
                            }
                            toHtData.fid = element.fieldId;
                            toHtData.inputName = element.inputFName;
                            toHtData.inputNameValue = value;
                            //循环子组件 分别进行子组件的需要传递到后台的数据获取
                            var childToHtData = that.getChildToHtData();
                            for(var key in childToHtData){
                                toHtData[key] = childToHtData[key];
                            }
                            that.$axios.post(url,toHtData).then( res => {
                                if(res.data+""!="true"){
                                  var mainId = res.data;
                                  if(typeof(that.zdyValiadFunExe)== "function") {
                                      that.zdyValiadFunExe(that, element.fieldId,mainId);
                                  } else {
                                    that.$emit("zdyValiadFun", element.fieldId,mainId);
                                  }
                                  return callback(new Error('数据已存在！'));
                                }else{
                                  return callback();
                                } 
                            },( err ) => {
                                return callback();
                            });
                        }
                    }
                    oneRules.push({
                        validator: checkDataToHt,
                        trigger: ['change'] 
                    });
                    addOrUpData[element.inputFName] = "";
                } 

                element.rules = oneRules;
                //多值选择项
                if(element.fieldRole == 17) {
                    addOrUpData[element.inputFName] = [];
                }
                if(element.fieldRole == 18 || element.fieldRole == 19) {
                    addOrUpData[element.inputFName+"_fileList"] = [];
                }
                //日期类型的字段
                if(element.fieldType == 3) {
                    if(element.dateType == null) {
                        element.dateType = "yyyy-MM-dd"
                    }
                    if(element.dateType.indexOf(":")>=0) {
                        element.vueType="datetime";
                    } else if(element.dateType == "yyyy-MM") {
                        element.vueType="month";
                    } else if(element.dateType == "yyyy") {
                        element.vueType="year";
                    } else {
                        element.vueType="date";
                    }
                }
                //只要是对象 有可能有子表格则
                if(element.fieldType == 5) {
                    addOrUpData[element.inputFName + '_childArr'] = [];
                    addOrUpData[element.inputFName + '_name'] = "";
                    //内部对象多值并且 展现形式是下拉框类型
                    if(element.fieldType == 5 && element.chooseType == 2) {
                        selectData21[element.inputFName] = [];
                        selectData21[element.inputFName+'_loading'] = false;
                    }
                    //内部对象多值并且 展现形式是下拉树类型
                    if(element.fieldType == 5 && element.chooseType == 1) {
                        selectData21[element.inputFName+'_openFlag'] = false;
                        selectData21[element.inputFName+'_tmpJsonData'] = "";
                    }
                    //判断类型是弹出层或者下拉框 判断展现形式addStyle == 2为默认选中
                    if(element.addStyle == 2) {
                        this.defaultChoose(element.fieldId);
                    }
                }
                
                if(this.initData != null && this.initData != undefined) {
                    //如果是修改页面 进行初始值的展示
                    this.replaceInitData(this.initData,element,addOrUpData,selectData21,fieldIndex);
                }
                //判断是否有默认值 或者 如果是修改页面 是否有初始值  如果是子表格 是否有初始值
                this.replaceFieldOneDefault(element,pageType,addOrUpData);
                
                fieldIndex++;
            })
        }
        this.selectData21 = selectData21;
        this.addOrUpData = addOrUpData;
        //页面加载后 初始化调用一次 隐藏显示的切换
        this.initChangeValueShowHide(0);
            
    },
    mounted:function(){
        var that = this;
        eval(this.customVueJs);
    },
    components:{
        TreePage
    },
    props: {
        /**
         * 页面的字段信息
         */
        tmpfieldSet: Array,
        /**
         * 前置的页面的层级关系
         */
        prevDateIndex:String,
        /**
         * 本次是第几条数据
         */
        nowDateIndex:String,
        /**
         * 本次的触发数据主键id
         */
        prevDataId:String,
        /**
         * 本页面的触发字段的id
         */
        prevFieldId:String,
        /**
         * 本页面的 字段和字段顺序的 关联关系
         */
        name_indexMap:Object,
        /**
         * 当前的页面主键
         */
        pageId:String,
        /**
         * 当前页面的数据主键 主要用于修改使用
         */
        mainDataId:String,
        /**
         * 页面的初始信息 例如修改页面的初始数据
         */
        initData:Object,
        /**
         * 如果是子表格打开的弹出层tableId
         */
        dialogTableId:String,
        /**
         * 页面类型
         */
        pageType:String,
        /*
         * 字段默认设置的显示和隐藏的js数组
         */
        showHideJsList:Array,
        /**
         * 临时变量 主要用于子模板调用父母版方法后 获取返回值
         */
        parentTmpValue:Object,
        /**
         * 页面设置的自定义js
         */
        customVueJs:String
    },
    watch: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 子表格的DIV增加边框样式 */
.childTableDiv{
    border:1px solid #000
}
/* form表单的元素增加宽度 */
.form_item_class{
    width:100%;
}
/* 添加修改页面的input的样式 宽度 */
.add_or_up_input{
    width:190px;
}
/* form表单下的content增加宽度 90%
.form_item_class > div{
    width:85%
} */
</style>